import React, { useEffect, useState, useRef } from "react";
import {
    Button,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Modal,
    ModalOverlay,
    ModalContent,
    CloseButton,
    useDisclosure,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../Redux";
import { API } from "../../Services"; // Uncomment when using API

export default function ChatMemberview({
    isViewMemberOpen,
    setIsViewMemberOpen,
    chatdata
}) {
    const state = useSelector((state) => state);
    const dispatch = useDispatch();
     const { trelloCardInfo,trelloCommentList} = bindActionCreators(actionCreators, dispatch);
    const [assignedMembers, setAssignedMembers] = useState([]);
    const [selectedMember, setSelectedMember] = useState(null);
    const projectID = chatdata?.projectCode ? chatdata?.projectCode : chatdata?.orderCode;

    const {
        isOpen: isDeleteOpen,
        onOpen: onDeleteOpen,
        onClose: onDeleteClose,
    } = useDisclosure();

    const cancelRef = useRef();
    useEffect(() => {
        loadAssignMemeber();
    }, [isViewMemberOpen]);

    const loadAssignMemeber = () => {
        API.showChatmemberlist(projectID)
            .then((res) => {
                let Data = res?.data;
                setAssignedMembers(Data?.data);
            }).catch(() => { })
            .finally(() => { });

    };

    const RemoveMember = (memberId) => {
        const data = { memberID: memberId };
        API.removeChatMemberList(projectID,data)
          .then(() => {
            toast.success("Member removed successfully", { position: "top-right" });
            loadAssignMemeber();
            trelloCardInfo(projectID);
            trelloCommentList(projectID, 20, 1);
          })
          .catch(() => {
            toast.error("Failed to remove member", { position: "top-right" });
          });
    };

    return (
        <>
            <Modal isOpen={isViewMemberOpen} onClose={() => setIsViewMemberOpen(false)}>
                <ModalOverlay />
                <ModalContent maxH="38rem" minH="15rem">
                    <ModalHeader display="flex" justifyContent="space-between">
                        Chat Members Assigned
                        <CloseButton onClick={() => setIsViewMemberOpen(false)} />
                    </ModalHeader>
                    <ModalBody>
                        <div className="viewchatmember-container">
                            <div className="viewchatmember-scroll">
                                <ul className="viewchatmember-ul">
                                    {assignedMembers.map((member) => (
                                        <li className="viewchatmember-item" key={member.id}>
                                            {member.name}
                                            <button
                                                className="viewchatmember-close"
                                                onClick={() => {
                                                    setSelectedMember(member);
                                                    onDeleteOpen();
                                                }}
                                            >
                                                ×
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                    </ModalBody>
                    <ModalFooter></ModalFooter>
                </ModalContent>
            </Modal>

            {/* Alert Dialog for Remove Confirmation */}
            <AlertDialog
                isOpen={isDeleteOpen}
                leastDestructiveRef={cancelRef}
                onClose={onDeleteClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Remove Member
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            Are you sure you want to remove {selectedMember?.name}?
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onDeleteClose} size="sm">
                                Cancel
                            </Button>
                            <Button
                                colorScheme="red"
                                onClick={() => {
                                    RemoveMember(selectedMember?.id);
                                    onDeleteClose();
                                }}
                                ml={3}
                                size="sm"
                            >
                                Remove
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

        </>
    );
}
